const ConfigChatBots = () => import('./Config.vue');
const NewChatBots = () => import('./New.vue');
const EditChatBots = () => import('./Edit.vue');
import { frontendURL } from '../../../../helper/URLHelper';
import {
  BOT_MANAGE_PERMISSIONS,
  BOT_CREATE_PERMISSIONS,
  BOT_EDIT_PERMISSIONS,
  BOT_DELETE_PERMISSIONS,
  BOT_KNOWLEDGE_MANAGE_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
const SettingsContent = () => import('../Wrapper.vue');

const BOT_MANAGEMENT_PERMISSIONS = [
  'administrator',
  BOT_MANAGE_PERMISSIONS,
  BOT_CREATE_PERMISSIONS,
  BOT_EDIT_PERMISSIONS,
  BOT_DELETE_PERMISSIONS,
  BOT_KNOWLEDGE_MANAGE_PERMISSIONS,
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/automations/chat-bots'),
      meta: {
        permissions: BOT_MANAGEMENT_PERMISSIONS,
      },
      component: SettingsContent,
      props: params => {
        const showBackButton = params.name === 'new_chat_bots' || params.name === 'edit_chat_bots';
        const backUrl = { name: 'config_chat_bots' };
        return {
          headerTitle: 'AGENT_BOTS.HEADER',
          icon: 'bot',
          showNewButton: false,
          showBackButton,
          backUrl,
        };
      },
      children: [
        {
          path: '',
          redirect: 'config',
        },
        {
          path: 'config',
          name: 'config_chat_bots',
          component: ConfigChatBots,
          meta: {
            permissions: BOT_MANAGEMENT_PERMISSIONS,
          },
        },
        {
          path: 'config/new',
          name: 'new_chat_bots',
          component: NewChatBots,
          meta: {
            permissions: ['administrator', BOT_CREATE_PERMISSIONS],
          },
        },
        {
          path: 'config/:botId',
          name: 'edit_chat_bots',
          component: EditChatBots,
          meta: {
            permissions: ['administrator', BOT_EDIT_PERMISSIONS],
          },
        },
      ],
    },
  ],
};
